import { Component, EventEmitter, Input, Output } from '@angular/core';
import { V3InfoButton } from '../v3-info-button/v3-info-button';

@Component({
  selector: 'app-v3-finnet-breadcrumb',
  templateUrl: './v3-finnet-breadcrumb.html',
  styleUrl: './v3-finnet-breadcrumb.scss',
  standalone: true,
  imports: [V3InfoButton],
})
export class V3FinnetBreadcrumb {
  @Input() title = '';
  // True on analysis subpages (V3Root); Terms/Privacy keep the default general InfoModal.
  @Input() infoOpensPage = false;
  // False on the tab's own info page — see v3-info-page/CLAUDE.md.
  @Input() showInfoButton = true;
  @Output() homeClicked = new EventEmitter<void>();
  @Output() infoClicked = new EventEmitter<void>();
}
